module.exports = __webpack_public_path__ + "img/Vehicle-2.3d6cfcbb.png";